import { liveTimestamp } from "@/lib/seo";
import { useGoldRates } from "@/lib/nonblocking-rates";

/**
 * LiveBadge — small reusable "🟢 Live · Updated Xm ago" pill.
 * Reads the same in-memory gold-rates query; no extra fetch.
 * Timezone default: PKT (Pakistan pages). Pass tz="IST" for India.
 */
export function LiveBadge({
  tz = "PKT",
  className = "",
  label = "Live",
}: {
  tz?: "PKT" | "IST";
  className?: string;
  label?: string;
}) {
  const { data } = useGoldRates();
  const updated = liveTimestamp(data.fetchedAt, tz);
  const iso = new Date(data.fetchedAt).toISOString();
  return (
    <div
      className={
        "inline-flex items-center gap-2 rounded-full border border-green-500/40 bg-green-500/10 px-3 py-1 text-xs font-semibold text-green-700 dark:text-green-400 " +
        className
      }
      aria-live="polite" data-nosnippet
    >
      <span className="relative inline-flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500" />
      </span>
      <span>🟢 {label} · Updated </span>
      <time dateTime={iso}>{updated}</time>
    </div>
  );
}

export default LiveBadge;